import React from "react";
import axios from "axios";
import { setup as URI_SETUP } from "../../../../../config/api";
import { Steps, Button, Icon, message, Form, Switch, Slider, InputNumber, Table, Input } from 'antd';
import {tblColsNewBudget, monthByNumber} from "../../../../../config/Helpers";

const Step = Steps.Step;
const { TextArea } = Input;
const ButtonGroup = Button.Group;
const uri_budget = URI_SETUP+"budget";

const budgetSteps = [{
    title: 'Define',
    content: 'define',
  }, {
    title: 'Fill',
    content: 'fill',
  }, {
    title: 'Activate',
    content: 'activate',
  }];

class BudgetNew extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current                   : 0,
            reference_years           : [],
            budget_years              : [],
            budget_periods            : [{
                                          key: 'year',
                                          title: 'Year',
                                          table_width: 400
                                        }, {
                                          key: 'month',
                                          title: 'Month',
                                          table_width: 1640
                                        } /*, {
                                          key: 'day',
                                          title: 'Day',
                                          table_width: 44000
                                        } */ ], 
            budget_depths            : [{
                                          key: 'global',
                                          title: 'Global',
                                        }, {
                                          key: 'segment',
                                          title: 'Segment',
                                        }, {
                                          key: 'agency',
                                          title: 'Segment / Agency',
                                        }],
            budget_bys            : [{
                                          key: 'amount',
                                          title: 'Amount',
                                        }, {
                                          key: 'percent',
                                          title: 'Percent',
                                        }],
            input_value_active        : "adr",
            budget_matrix_maped       : [],
            sts_budget_edit_box       : "arrows-alt",
            is_loading_matrix_table   : true,                 
            active_budget             : {
                                        period              : "",
                                        year                : "",
                                        reference_year      : "",
                                        depth               : "",
                                        capture_format      : "",
                                        expected_growth     : 0,
                                        growth              : 0,
                                        matrix              : [],
                                        status              : "draft",
                                        short_description   : "",
                                        details             : "",
                                      }
            }
    }

    componentWillMount(){
        this.getAvailableYears();
        //this.mapBudgetMatrixRows();
        if(this.props.active_budget._id!=undefined){
          this.getFullBudgetDetails(this.props.active_budget._id);
                  
          if(this.state.current<1){
            this.setState({ current : 1 })
          }
          
        }
    } 

    componentDidUpdate(prevProps, prevState) {
      
      if (prevState.active_budget != this.state.active_budget) {
          
          if(this.state.active_budget.matrix!=[]){
            this.mapBudgetMatrixRows();
            /*
            if(this.state.current<1){
              this.setState({ current : 1 })
            }
            */
            
          }
        }
        
    }

    // ----------------------- Handlers -----------------------

    handleActivateBudget(checked) {
      console.log(`switch to ${checked}`);
    }

    handleBudgetInfoInput(e){
        const target = e.target;
        const name = target.name;
        const value = target.value;
        let active_budget = this.state.active_budget;
        active_budget[name] = value;
        this.setState({
            active_budget
        });
    }
    
    handleBudgetEditBoxStatus(){
      let sts_budget_edit_box = this.state.sts_budget_edit_box;
      if(sts_budget_edit_box=="arrows-alt"){
        sts_budget_edit_box="shrink";
      }else{
        sts_budget_edit_box="arrows-alt";
      }
      this.setState({ sts_budget_edit_box });
    }
    
    handleActiveBudget = (e) => {
        let active_budget = Object.assign({}, this.state.active_budget);
        active_budget[e.target.name] = e.target.value;
        this.setState({  active_budget }); 
    }

    handleInputMatrixBlur = (e) => {
      let active_budget = Object.assign({}, this.state.active_budget);
      let row=e.target.getAttribute('data-row');
      let col=e.target.getAttribute('data-col');
      let type= this.state.input_value_active;
      let totals={};
      let row_agency=(e.target.getAttribute('data-row-agency')!=undefined)? e.target.getAttribute('data-row-agency') : null ;
      if(row_agency==null){
        active_budget.matrix[row].cols[col][type].value=Number(e.target.value);
        if(active_budget.capture_format=='amount'){
          active_budget.matrix[row].cols[col]['revenue'].value = Number(active_budget.matrix[row].cols[col]['adr'].value * active_budget.matrix[row].cols[col]['nights'].value).toFixed(2);
        }else{
          active_budget.matrix[row].cols[col]['revenue'].value = Number(
            ( ( (Number(active_budget.matrix[row].cols[col]['adr'].value) /100) * Number(active_budget.matrix[row].cols[col]['adr'].ref) ) + Number(active_budget.matrix[row].cols[col]['adr'].ref) ) 
          * ( ( (Number(active_budget.matrix[row].cols[col]['nights'].value) /100) * Number(active_budget.matrix[row].cols[col]['nights'].ref) ) + Number(active_budget.matrix[row].cols[col]['nights'].ref) )
          ).toFixed(2);
        }
        
        totals = this.gridGralTotalizer(active_budget.matrix, active_budget.capture_format);
      }else{
        active_budget.matrix[row].cols[col][type].value = Number(active_budget.matrix[row].cols[col][type].value) + Number(e.target.value);
        active_budget.matrix[row].agencies[row_agency].cols[col][type].value=Number(e.target.value);
        active_budget.matrix[row].agencies[row_agency].cols[col]['revenue'].value = Number(active_budget.matrix[row].agencies[row_agency].cols[col]['adr'].value).toFixed(2) * Number(active_budget.matrix[row].agencies[row_agency].cols[col]['nights'].value).toFixed(2);
        active_budget.matrix[row].cols[col]['revenue'].value = Number(active_budget.matrix[row].cols[col]['revenue'].value) + Number(active_budget.matrix[row].agencies[row_agency].cols[col]['revenue'].value);
        totals = this.gridAgencyTotalizer(active_budget.matrix, active_budget.capture_format);

        totals.segments.map(function(row_totals, i){
          Object.keys(row_totals.cols).map(function(row_totals_cols, j){
            active_budget.matrix[i].cols[row_totals_cols][type].value = row_totals.cols[row_totals_cols][type];
          });
        });
        

      }
      active_budget.totals['revenue'].value = Number(totals.revenue);
      active_budget.totals['nights'].value = Number(totals.nights); 
      active_budget.totals['adr'].value = Number(totals.adr);  
      active_budget.growth = (active_budget.totals['revenue'].ref==0 ? 0 : (((Number(active_budget.totals['revenue'].value)/Number(active_budget.totals['revenue'].ref)) *100)-100).toFixed(0) );

      if(row_agency==null){
        
        this.saveBudgetInput(active_budget._id, active_budget.depth, row, type, col, active_budget.matrix[row].cols[col], active_budget.totals, active_budget.growth );
      }else{
        
        this.saveBudgetInput(active_budget._id, active_budget.depth, row, type, col, active_budget.matrix[row].agencies[row_agency].cols[col], active_budget.totals, active_budget.growth, row_agency, active_budget.matrix[row].cols[col] );
      }
      this.setState({  active_budget }); 
    }
    

    handlePercentageGrowth = (value) => {
        let active_budget = Object.assign({}, this.state.active_budget);
        active_budget.expected_growth = Number(value);
        this.setState({  active_budget }); 
    }

    handleValueActive (input_value_active) {
      this.setState({ 
        input_value_active : input_value_active
      })
      this.mapBudgetMatrixRows(input_value_active);
    }

    // ----------------------- Functions -----------------------

    gridGralTotalizer(grid, capture_format){
      let totals = {
                    'adr'     : 0,
                    'nights'  : 0,
                    'revenue' : 0
                  };
      grid.map(function(row, i){
        Object.keys(row.cols).map(function(row_cols, j){

            if(capture_format=='amount'){
              totals.adr = Number(totals.adr) + Number(row.cols[row_cols].adr.value);
              totals.nights = Number(totals.nights) + Number(row.cols[row_cols].nights.value);
              totals.revenue = Number(totals.revenue) + Number(row.cols[row_cols].revenue.value);
            }else{
              totals.adr = Number(totals.adr) + ( Number(row.cols[row_cols].adr.ref) + ( (Number(row.cols[row_cols].adr.value) /100) * Number(row.cols[row_cols].adr.ref) ) );
              totals.nights = Number(totals.nights) + ( Number(row.cols[row_cols].nights.ref) + ( (Number(row.cols[row_cols].nights.value) /100) * Number(row.cols[row_cols].nights.ref) ) );
              totals.revenue = Number(totals.revenue) + ( Number(row.cols[row_cols].revenue.ref) + ( (Number(row.cols[row_cols].revenue.value) /100) * Number(row.cols[row_cols].revenue.ref) ) );
            }
            
        });
      });
      
      return totals;

    }

    gridAgencyTotalizer(grid, capture_format){
      let totals = {
                    'adr'     : 0,
                    'nights'  : 0,
                    'revenue' : 0,
                    'segments': []   
                  };
      grid.map(function(row, i){
        if(totals.segments[i]==undefined){
          totals.segments[i]={'cols' : []};
        }
        if(row.agencies!=undefined){  
          row.agencies.map(function(row_agency, k){
            Object.keys(row_agency.cols).map(function(row_agency_cols, j){
              if(totals.segments[i].cols[row_agency_cols]==undefined){
                totals.segments[i].cols[row_agency_cols] = {
                  'adr'     : 0,
                  'nights'  : 0,
                  'revenue' : 0 
                };
              }
              if(capture_format=='amount'){
                totals.segments[i].cols[row_agency_cols].adr = Number(totals.segments[i].cols[row_agency_cols].adr) + Number(row_agency.cols[row_agency_cols].adr.value);
                totals.segments[i].cols[row_agency_cols].nights = Number(totals.segments[i].cols[row_agency_cols].nights) + Number(row_agency.cols[row_agency_cols].nights.value);  
                totals.segments[i].cols[row_agency_cols].revenue = Number(totals.segments[i].cols[row_agency_cols].revenue) + Number(row_agency.cols[row_agency_cols].revenue.value);

                totals.adr = Number(totals.adr) + Number(row_agency.cols[row_agency_cols].adr.value);
                totals.nights = Number(totals.nights) + Number(row_agency.cols[row_agency_cols].nights.value);  
                totals.revenue = Number(totals.revenue) + Number(row_agency.cols[row_agency_cols].revenue.value);
              }else{

                totals.segments[i].cols[row_agency_cols].adr = Number(totals.segments[i].cols[row_agency_cols].adr) 
                                                              + ( Number(row_agency.cols[row_agency_cols].adr.ref) + ( (Number(row_agency.cols[row_agency_cols].adr.value) /100) * Number(row_agency.cols[row_agency_cols].adr.ref) ) );
                totals.segments[i].cols[row_agency_cols].nights = Number(totals.segments[i].cols[row_agency_cols].nights) 
                                                              + ( Number(row_agency.cols[row_agency_cols].nights.ref) + ( (Number(row_agency.cols[row_agency_cols].nights.value) /100) * Number(row_agency.cols[row_agency_cols].nights.ref) ) );   
                totals.segments[i].cols[row_agency_cols].revenue = Number(totals.segments[i].cols[row_agency_cols].revenue) 
                                                              + ( Number(row_agency.cols[row_agency_cols].revenue.ref) + ( (Number(row_agency.cols[row_agency_cols].revenue.value) /100) * Number(row_agency.cols[row_agency_cols].revenue.ref) ) );

                totals.adr = Number(totals.adr) + ( Number(row_agency.cols[row_agency_cols].adr.ref) + ( (Number(row_agency.cols[row_agency_cols].adr.value) /100) * Number(row_agency.cols[row_agency_cols].adr.ref) ) );
                totals.nights = Number(totals.nights) + ( Number(row_agency.cols[row_agency_cols].nights.ref) + ( (Number(row_agency.cols[row_agency_cols].nights.value) /100) * Number(row_agency.cols[row_agency_cols].nights.ref) ) ); 
                totals.revenue = Number(totals.revenue) + ( Number(row_agency.cols[row_agency_cols].revenue.ref) + ( (Number(row_agency.cols[row_agency_cols].revenue.value) /100) * Number(row_agency.cols[row_agency_cols].revenue.ref) ) );
              }

            });
          });
        }
          
      });
      return totals;
    }
    
    getFullBudgetDetails(id){
        this.setState({ is_loading_matrix_table    : true});
        let self = this;
        axios.get(uri_budget+"/"+id, { 
            params: {
                api_token       : localStorage.getItem("api_token")
            }
        }).then(request => { 
            self.setState({ 
                active_budget              : request.data,
                is_loading_matrix_table    : false
            }) 
        })
    }

    saveBudget(active_budget=null){
      let self = this;
      var qs = require("qs");
      
      active_budget = (active_budget!=null)? active_budget : Object.assign({}, this.state.active_budget);

      active_budget["property_id"] = self.props.hotel_selected;
      active_budget["api_token"]=localStorage.getItem("api_token");
      const itemToSent = qs.stringify(active_budget);

      if(active_budget._id==undefined){
          axios.post(uri_budget, itemToSent)
                  .then(request => { 
                    self.setState({ 
                      active_budget              : request.data
                    });
                  })
      }else{
          axios.post(uri_budget+"/"+active_budget._id, itemToSent)
          .then(request => { 
            self.setState({ 
              active_budget              : request.data
            });
          })

      }
      
    }

    saveBudgetInput(budget_id, depth, row, value_type, col, values, totals, growth, row_agency=0, segment_totals=[] ){
      let self = this;
      var qs = require("qs");
      let item=[];
      item["api_token"]=localStorage.getItem("api_token");
      item["depth"] = depth;
      item["row"] = row;
      item["value_type"] = value_type;
      item["col"] = col;
      item["row_agency"] = row_agency;
      item["values"] = values;
      item["totals"] = totals;
      item["segment_totals"] = segment_totals;
      item["growth"] = growth;
      item["mode"]="update_input";
      const itemToSent = qs.stringify(item);

      axios.post(uri_budget+"/"+budget_id, itemToSent)
      .then(request => { 
        /*
        self.setState({ 
          active_budget              : request.data
        });
        */
      })

      
      
    }
    
    mapBudgetMatrixRows(value_active){
      this.setState({ is_loading_matrix_table    : true});
      let maped_rows=[];
      let maped_row={};
      let self=this;
      let input_value_active=(value_active==null )? self.state.input_value_active : value_active ;
      if(self.state.active_budget!=undefined){
        self.state.active_budget.matrix.map(function(row, i){
            maped_row={};
            maped_row[self.state.active_budget.depth]=row.name;
            maped_row["key"]=self.state.active_budget.depth+"row"+i;
            switch(self.state.active_budget.depth){
              case "segment": 
              case "global": 
                Object.keys(row.cols).map(function(row_cols, j){
                  maped_row[self.state.active_budget.depth+row_cols]=<div className="cell-with-input">
      
                                <input className={(input_value_active=='adr')? "": "hide" } 
                                  defaultValue={row.cols[row_cols].adr.value} type="number"
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_cols} data-row={i}
                                  onFocus={e => e.target.select()} 
                                />
                                <div className={"cell-diff " 
                                                  + (input_value_active=='adr' ? "": "hide" )
                                                  + (self.state.active_budget.capture_format=='amount' ? 
                                                        (row.cols[row_cols].adr.ref==row.cols[row_cols].adr.value ? " same" : (Number(row.cols[row_cols].adr.ref)>Number(row.cols[row_cols].adr.value) ? " down": " up" ) ) : 
                                                        (Number(row.cols[row_cols].adr.value)==0 ? " same" : (Number(row.cols[row_cols].adr.value<0) ? " down": " up" ) ) ) }> 
                                                    {(Number(row.cols[row_cols].adr.ref)==0 ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(row.cols[row_cols].adr.value)/Number(row.cols[row_cols].adr.ref)) *100)-100).toFixed(2) : row.cols[row_cols].adr.value ) + "%" ) } 
                                </div>
                                <div className={(input_value_active=='adr'? "": "hide" )}> {row.cols[row_cols].adr.ref} </div>
      
                                <input className={(input_value_active=='nights')? "": "hide" } 
                                  defaultValue={row.cols[row_cols].nights.value} type="number" 
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_cols} data-row={i}
                                  onFocus={e => e.target.select()} 
                                />
                                <div className={"cell-diff " 
                                                + (input_value_active=='nights' ? "": "hide" )
                                                + (self.state.active_budget.capture_format=='amount' ? 
                                                      (row.cols[row_cols].nights.ref==row.cols[row_cols].nights.value ? " same" : (Number(row.cols[row_cols].nights.ref)>Number(row.cols[row_cols].nights.value) ? " down": " up" ) ) : 
                                                      (Number(row.cols[row_cols].nights.value)==0 ? " same" : (Number(row.cols[row_cols].nights.value)<0 ? " down": " up" ) ) ) }> 
                                                  {(Number(row.cols[row_cols].nights.ref)==0 ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(row.cols[row_cols].nights.value)/Number(row.cols[row_cols].nights.ref)) *100)-100).toFixed(2) : row.cols[row_cols].nights.value ) + "%" ) } 
                                </div>
                                <div className={(input_value_active=='nights'? "": "hide" )}> {row.cols[row_cols].nights.ref}  </div>
      
                                <input className={(input_value_active=='revenue')? "": "hide" } 
                                  value={row.cols[row_cols].revenue.value} type="number" 
                                  
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_cols} data-row={i}
                                  disabled
                                />
                                <div className={"cell-diff " 
                                                + (input_value_active=='revenue' ? "": "hide" )
                                                + (row.cols[row_cols].revenue.ref==row.cols[row_cols].revenue.value ? " same" : (Number(row.cols[row_cols].revenue.ref)>Number(row.cols[row_cols].revenue.value) ? " down": " up" ) ) }> 
                                                {(Number(row.cols[row_cols].revenue.ref)==0 ? "N/A" : (((Number(row.cols[row_cols].revenue.value)/Number(row.cols[row_cols].revenue.ref))*100)-100).toFixed(2) ) } 
                                </div>
                                <div className={(input_value_active=='revenue'? "": "hide" )}> {row.cols[row_cols].revenue.ref} </div>
                              
                              </div>;
                });

                maped_rows.push(maped_row);
                break;
              case "agency": 
                Object.keys(row.cols).map(function(row_cols, j){
                    maped_row[self.state.active_budget.depth+row_cols]=
                        <div className="cell-with-input">
                          <div className={"cell-subtotal " + (input_value_active=='adr' ? "": "hide" )} >{row.cols[row_cols].adr.value}</div>
                          <div className={"cell-subtotal " + (input_value_active=='nights' ? "": "hide" )} >{row.cols[row_cols].nights.value}</div>
                          <div className={"cell-subtotal " + (input_value_active=='revenue' ? "": "hide" )} >{row.cols[row_cols].revenue.value}</div>    
                        </div>;
                  });
                maped_rows.push(maped_row);
                maped_row={};
                if(row.agencies!=undefined){  
                  row.agencies.map(function(row_agency, k){
                      maped_row={};
                      maped_row[self.state.active_budget.depth]=row_agency.name;
                      maped_row["key"]=self.state.active_budget.depth+"row_agency"+i+"_"+k;
                      
                      Object.keys(row_agency.cols).map(function(row_agency_cols, j){
                        maped_row[self.state.active_budget.depth+row_agency_cols]=<div className="cell-with-input">
            
                                      <input className={(input_value_active=='adr')? "": "hide" } 
                                        defaultValue={row_agency.cols[row_agency_cols].adr.value} type="number" 
                                        onBlur={self.handleInputMatrixBlur.bind(self)}
                                        data-col={row_agency_cols} data-row={i} data-row-agency={k}
                                        onFocus={e => e.target.select()} 
                                      />
                                      <div className={"cell-diff " 
                                                  + (input_value_active=='adr' ? "": "hide" )
                                                  + (self.state.active_budget.capture_format=='amount' ? 
                                                        (row_agency.cols[row_agency_cols].adr.ref==row_agency.cols[row_agency_cols].adr.value ? " same" : (Number(row_agency.cols[row_agency_cols].adr.ref)>Number(row_agency.cols[row_agency_cols].adr.value) ? " down": " up" ) ) : 
                                                        (Number(row_agency.cols[row_agency_cols].adr.value)==0 ? " same" : (Number(row_agency.cols[row_agency_cols].adr.value<0) ? " down": " up" ) ) ) }> 
                                                    {(Number(row_agency.cols[row_agency_cols].adr.ref)==0 ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(row_agency.cols[row_agency_cols].adr.value)/Number(row_agency.cols[row_agency_cols].adr.ref)) *100)-100).toFixed(2) : row_agency.cols[row_agency_cols].adr.value ) + "%" ) } 
                                      </div>
                                      { /*
                                      <div className={"cell-diff " 
                                                        + (input_value_active=='adr' ? "": "hide" )
                                                        + (row_agency.cols[row_agency_cols].adr.ref==row_agency.cols[row_agency_cols].adr.value ? " same" : (row_agency.cols[row_agency_cols].adr.ref>row_agency.cols[row_agency_cols].adr.value ? " down": " up" ) ) }> 
                                                          {(row_agency.cols[row_agency_cols].adr.ref==0 ? "N/A" : (((row_agency.cols[row_agency_cols].adr.value/row_agency.cols[row_agency_cols].adr.ref) *100)-100).toFixed(2) )} 
                                      </div>
                                      */ }
                                      <div className={(input_value_active=='adr'? "": "hide" )}> {row_agency.cols[row_agency_cols].adr.ref} </div>
            
                                      <input className={(input_value_active=='nights')? "": "hide" } 
                                        defaultValue={row_agency.cols[row_agency_cols].nights.value} type="number" 
                                        onBlur={self.handleInputMatrixBlur.bind(self)}
                                        data-col={row_agency_cols} data-row={i} data-row-agency={k}
                                        onFocus={e => e.target.select()} 
                                      />
                                      <div className={"cell-diff " 
                                                + (input_value_active=='nights' ? "": "hide" )
                                                + (self.state.active_budget.capture_format=='amount' ? 
                                                      (row_agency.cols[row_agency_cols].nights.ref==row_agency.cols[row_agency_cols].nights.value ? " same" : (Number(row_agency.cols[row_agency_cols].nights.ref)>Number(row_agency.cols[row_agency_cols].nights.value) ? " down": " up" ) ) : 
                                                      (Number(row_agency.cols[row_agency_cols].nights.value)==0 ? " same" : (Number(row_agency.cols[row_agency_cols].nights.value)<0 ? " down": " up" ) ) ) }> 
                                                  {(Number(row_agency.cols[row_agency_cols].nights.ref)==0 ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(row_agency.cols[row_agency_cols].nights.value)/Number(row_agency.cols[row_agency_cols].nights.ref)) *100)-100).toFixed(2) : row_agency.cols[row_agency_cols].nights.value ) + "%" ) } 
                                      </div>

                                      { /*
                                      <div className={"cell-diff " 
                                                      + (input_value_active=='nights' ? "": "hide" )
                                                      + (row_agency.cols[row_agency_cols].nights.ref==row_agency.cols[row_agency_cols].nights.value ? " same" : (row_agency.cols[row_agency_cols].nights.ref>row_agency.cols[row_agency_cols].nights.value ? " down": " up" ) ) }> 
                                                        {(row_agency.cols[row_agency_cols].nights.ref==0 ? "N/A" : (((row_agency.cols[row_agency_cols].nights.value/row_agency.cols[row_agency_cols].nights.ref)*100)-100) )} 
                                      </div>
                                      */ }
                                      <div className={(input_value_active=='nights'? "": "hide" )}> {row_agency.cols[row_agency_cols].nights.ref}  </div>
            
                                      <input className={(input_value_active=='revenue')? "": "hide" } 
                                        value={row_agency.cols[row_agency_cols].revenue.value} type="number" 
                                        onBlur={self.handleInputMatrixBlur.bind(self)}
                                        data-col={row_agency_cols} data-row={i} data-row-agency={k}
                                        disabled
                                      />

                                      <div className={"cell-diff " 
                                                + (input_value_active=='revenue' ? "": "hide" )
                                                + (row_agency.cols[row_agency_cols].revenue.ref==row_agency.cols[row_agency_cols].revenue.value ? " same" : (Number(row_agency.cols[row_agency_cols].revenue.ref)>Number(row_agency.cols[row_agency_cols].revenue.value) ? " down": " up" ) ) }> 
                                                {(Number(row_agency.cols[row_agency_cols].revenue.ref)==0 ? "N/A" : (((Number(row_agency.cols[row_agency_cols].revenue.value)/Number(row_agency.cols[row_agency_cols].revenue.ref))*100)-100).toFixed(2) ) } 
                                      </div>

                                      { /*
                                      <div className={"cell-diff " 
                                                      + (input_value_active=='revenue' ? "": "hide" )
                                                      + (row_agency.cols[row_agency_cols].revenue.ref==row_agency.cols[row_agency_cols].revenue.value ? " same" : (row_agency.cols[row_agency_cols].revenue.ref>row_agency.cols[row_agency_cols].revenue.value ? " down": " up" ) ) }> 
                                                      {(row_agency.cols[row_agency_cols].revenue.ref==0 ? "N/A" : (((row_agency.cols[row_agency_cols].revenue.value/row_agency.cols[row_agency_cols].revenue.ref)*100)-100).toFixed(2) ) } </div>
                                      */ }
                                      <div className={(input_value_active=='revenue'? "": "hide" )}> {row_agency.cols[row_agency_cols].revenue.ref} </div>
                                    
                                    </div>;
                      });
                    maped_rows.push(maped_row);
                  });
                }


                break;
                /*
              case "global": 


                maped_rows.push(maped_row);
                break;
                */

            }
            
            });
        }
        this.setState({ 
          budget_matrix_maped : maped_rows,
          is_loading_matrix_table    : false
        })

  }

    getAvailableYears(){
        let actual_year = new Date().getFullYear();
        let budget_years = [];
        for (let i = (actual_year-1); i < (actual_year+2); i++) {
            budget_years.push({
                year            : i,
                status          : ""
            });
        }
        this.setState({ 
            budget_years    : budget_years
        })        
    }
    
    next() {
      
      let active_budget = Object.assign({}, this.state.active_budget);
      let msg = {};
      msg = { 
        title               : "BUDGET",
        msg                 : "Annual budget draft successfully saved",
        day                 : "Now",
        progress            : 0,
        datetime            : Date.now()
        }
      
      let current = this.state.current;
      switch(current){
        case 0 : 
          if(active_budget.period!='' && active_budget.year!='' && active_budget.reference_year!='' && active_budget.depth!='' && active_budget.capture_format!='' ){
            if(active_budget._id==undefined){
             this.saveBudget(active_budget);
            }
            current++;
          } else{
            msg.msg="Some information is missing please review the Budget setup form";
          }
          this.props.handleNotification("tmp","new",msg);

        break;
        default:
          current++;

      }

      this.setState({ current });

      }
    
      prev() {
        const current = this.state.current - 1;
        this.setState({ current });
      }

      cancel(){
        this.props.resetActiveBudget();
        this.props.setActiveBudgetSection("budget-list");
      }

    // ----------------------- Renders -----------------------

    renderSteps(content){
      switch (content){
        case "define":
            return(
              <Form >
                <div className="form-row">
                
                  <div className="col col-md-6">
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="period"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.period }  
                            >
                          <option value="" disabled>Budget Period</option>
                          {Object.keys(this.state.budget_periods).map(item => <option key={item} value={this.state.budget_periods[item].key}>{this.state.budget_periods[item].title }</option>)}
                        </select>
                      </div>  
                    </div>
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="year"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.year }  
                            >
                            <option value="" disabled>Budget Year</option>
                            { Object.keys(this.state.budget_years).map((key) => {
                                    return( <option key={key} value={this.state.budget_years[key].year} >
                                        {this.state.budget_years[key].year}
                                    </option>);
                                })
                            }
                        </select> 
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="reference_year"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.reference_year }  
                            >
                              <option value="" disabled>Reference Year</option>
                              <option value="0">No reference</option>
                              { (this.state.reference_years!= undefined) &&
                                this.props.app.state.reference_years.map(function(name, index){
                                  return <option key={ index }>{name}</option>;
                                })
                              }
                        </select> 
                      </div>
                    </div>  
                  </div>
                  <div className="col col-md-6">
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="depth"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.depth }  
                            >
                              <option value="" disabled>Budget Depth</option>
                              {Object.keys(this.state.budget_depths).map(item => <option key={item} value={this.state.budget_depths[item].key}>{this.state.budget_depths[item].title }</option>)}
                        </select> 
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="capture_format"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.capture_format }  
                            >
                              <option value="" disabled>Define Budget by</option>
                              {Object.keys(this.state.budget_bys).map(item => <option key={item} value={this.state.budget_bys[item].key}>{this.state.budget_bys[item].title}</option>)}
                        </select> 
                      </div>
                    </div>

                    <div className="form-row growth-input">
                      <div className="col col-md-4 lbl-grw-left-alone">
                        Expected <br />Growth (%)
                      </div>
                      <div className="col col-md-4">
                        <Slider
                          min={0}
                          max={100}
                          marks={{0: '0%', 100: '100%'}}
                          onChange={this.handlePercentageGrowth}
                          value={ this.state.active_budget.expected_growth }  
                        />
                      </div>
                      <div className="col col-md-1 percent-input">
                        <InputNumber
                          min={1}
                          max={100}
                          value={ this.state.active_budget.expected_growth }
                          onChange={this.handlePercentageGrowth}
                        />
                      </div>
                      <div className="col col-md-1 percent-symb">%</div>
                    </div>

                    <div className="form-row">
                      <div className="col col-md-5 align-right">
                          Apply growth to budget
                      </div>
                      <div className="col col-md-2">
                          <Switch onChange={this.handleActivateBudget} />
                      </div>
                    </div>


                  </div>
                </div>
              </Form>
            );


          break;
        case "fill":
          return(
            <Form >
              <div className="form-row">

                <div className="col col-md-2">
                  Input Values
                </div>
                <div className="col col-md-4">
                <ButtonGroup>
                  <Button className={(this.state.input_value_active=="adr")?"selected":""} onClick={this.handleValueActive.bind(this,"adr")} >ADR</Button>
                  <Button className={(this.state.input_value_active=="nights")?"selected":""} onClick={this.handleValueActive.bind(this,"nights")} >Room Nights</Button>
                  <Button className={"informative " + (this.state.input_value_active=="revenue" ? "selected" : "") } onClick={this.handleValueActive.bind(this,"revenue")} >Revenue</Button>
                </ButtonGroup>
                </div>
                <div className="col col-md-2 budget-details">
                  <h4>Year</h4> 
                  {this.state.active_budget.year}
                  <span className="reference-info">{this.state.active_budget.reference_year}</span>
                </div>
                <div className="col col-md-2 budget-details">
                  <h4>Growth (%)</h4> 
                  {this.state.active_budget.expected_growth}  
                  <div className="reference-info gray">{this.state.active_budget.growth}</div>
                </div>

                <div className="col col-md-2 budget-details">
                  <h4>Capture by</h4> 
                  <span className="reference-info">{this.state.active_budget.capture_format}</span>
                </div>
                   
              </div>
              <div className="form-row">
                <div className="col col-md-12">
                  {this.is_loading_matrix_table &&
                    <Icon type="loading" />
                  }
                  { 
                    (this.state.active_budget.year!="" && this.state.active_budget.budget_period!="" && this.state.active_budget.budget_depth!=""  ) && 
                     <Table 
                        columns={tblColsNewBudget(this.state.active_budget.year,
                                                  this.state.active_budget.reference_year, 
                                                  this.state.budget_periods.find(period => period.key === this.state.active_budget.period), 
                                                  this.state.budget_depths.find(depth => depth.key === this.state.active_budget.depth), )} 
                        scroll={{ x: this.state.budget_periods.find(period => period.key === this.state.active_budget.period).table_width /*, y : 200 */  }} 
                        dataSource={this.state.budget_matrix_maped}
                        pagination={ false }
                        /* loading={this.is_loading_matrix_table} */ />
                  }
                  
                </div>
              </div>
              



            </Form>);         

          break;
        case "activate":
          return(
            <Form >
              <div className="form-row">

                <div className="col col-md-6">
                  <div className="form-row">
                      <div className="col col-md-12">
                          <input type="text" className="form-control" name="short_description" placeholder="Short Description" value={this.state.active_budget.short_description} required  onChange={e => this.handleBudgetInfoInput(e)} />          
                      </div>
                  </div>
                  <div className="form-row">
                    <div className="col col-md-10 align-right">
                        Set as active Budget
                    </div>
                    <div className="col col-md-2">
                        <Switch onChange={this.handleActivateBudget} />
                    </div>
                  </div>
                </div>
                <div className="col col-md-6">
                  <div className="form-row">
                      <div className="col col-md-12">
                        <TextArea 
                          rows={4} placeholder="Budget Details" 
                          value={this.state.active_budget.details}
                        />
                      </div>
                  </div>
                </div>

              </div>
            </Form>
          );

          break;
      }
      
    }

    render() {
        const { current } = this.state;
        
        return (
          <div className={"box regular col-md-12 " +  ( this.state.sts_budget_edit_box=='shrink'? 'maximized' : '' ) } >
            <h3>
              New Budget  
              <Icon className="clickable" type= {this.state.sts_budget_edit_box} onClick={this.handleBudgetEditBoxStatus.bind(this)} />
            </h3>
            <div className="table-in-box"><br />
              <div className="ant-container">
                <Steps current={current}>
                  {budgetSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content steps-budget">
                  <div className="form-in-box">
                    {this.renderSteps(budgetSteps[current].content)}
                  </div>
                </div>
                <div className="steps-action">
                  { current > 1 &&  (
                    <div className="col col-md-4">
                      <button onClick={() => this.prev()}>
                        Previous
                      </button>
                    </div>
                  )}
                  { current < budgetSteps.length - 1 && 
                    <div className="col col-md-4">
                      <button className="blue" onClick={() => this.next()}>Next</button>
                    </div>
                  }
                  
                  { current === budgetSteps.length - 1 && 
                    <div className="col col-md-4">
                      <button  onClick={() => message.success('Processing complete!')}>Done</button>
                    </div>
                  }
                  <div className="col col-md-4">
                    <button className="remove" onClick={() => this.cancel()}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

    }

}

export default BudgetNew


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/budget/BudgetEdit.js